module.exports = __webpack_public_path__ + "assets/telemedicine.19d9c2ba.png";